import { render } from "./LocationDetails.vue?vue&type=template&id=bc1eb084&scoped=true"
import script from "./LocationDetails.vue?vue&type=script&lang=js"
export * from "./LocationDetails.vue?vue&type=script&lang=js"

import "./LocationDetails.vue?vue&type=style&index=0&id=bc1eb084&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1eb084"]])

export default __exports__